<template>
<div style="max-width: 600px;">
    <div v-if="!showMe">устарело</div>
    <div v-if="showMe">
        <h1>
            <template v-if="afterbook.bookData.offer">
                Заявка создана!
            </template>
            <template v-else>{{afterbook.status.ok ? 'Забронировано!' : 'Заявка должна появиться в личном кабинете'}}</template>
        </h1>

        <div class="p" v-if="afterbook.claim_num"><a :href="href">Перейти к заявке {{afterbook.claim_num}}</a></div>

        <div v-if="!afterbook.status.ok" class="dobook_wait">
            <h2>В {{ts_plus}} проверьте личный кабинет</h2>
            <div class="l">Бронирование может длиться вплоть до 10 минут</div>
            <div class="l">Пожалуйста не заводите повторную заявку, пока не проверите личный кабинет</div>

            <div v-if="is" class="tm">{{leave_min}}</div>
            <div v-else class="l">
                <a href="/workspace/tours/">Перейти в личный кабинет</a>
            </div>
        </div>


        <div class="p" v-if="!afterbook.bookData.offer">
            Предварительная стоимость без учета некоторых скидок 
            <PriceCurrencyV class="price" :sum="true" :price="pre_price" />
        </div>

        <div class="p">
            <p v-for="str in messagelist">{{str}}</p>
        </div>
    </div>


</div>
</template>

<style lang="scss" src="./CruiseBookPage.scss"></style>

<script setup>
import {unref, ref, watch, computed, onMounted, reactive} from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
import {LOCALSTOR_BOOK_KEY} from '@/localStor.js'
import {CRUISE_BOOK_MAX} from '@/actions.js'
import {book_sumV} from '@/comp/useCruiseOrderCheck.js'
import dayjs from 'dayjs'
import useTimer from '@/comp/timer.js'
import PriceCurrencyV from '@/comp/CruiseHead/PriceCurrencyV.vue'

const route = useRoute()
const router = useRouter()

const {start_timer, stop_timer, attempt_timer, tick_timer, leave_min, is} = useTimer()

const afterbook_init = () => {
    return {
        sid: null,
        message: null,
        claim_id: null,
        claim_num: null,
        bookData: null,
        calc_prices: null,
        status: {ok:true, ts: null, },
    }
}

const afterbook = ref( afterbook_init() )

const messagelist = computed( ()=> {
    let a = afterbook.value.message.split("\n")
    return a
})

const ts_plus = computed( () => {
    let {ts} = unref(afterbook).status
    let ret = '??:??'
    if (ts) {
        ret = ts_add_max(ts).format('HH:mm')
    }
    return ret
})

const ts_add_max = (ts) => {
    return dayjs( ts ).add(CRUISE_BOOK_MAX,'s')
}


const pre_price = computed( () => {
    let ret = { v: [ null, 1 ] }
    const { calc_prices } = unref( afterbook )
    if (calc_prices) {
        ret = book_sumV( calc_prices )
    }
    return ret
} )

    
const showMe = computed( () => {
    return route.query.sid === unref(afterbook).sid
})

const href = computed( () => {
    const claim_id = unref(afterbook).claim_id
    return `/workspace/tours/?id=${claim_id}`
})

watch( 
    [   
        () => route.query.sid,
    ],
    () => {
        try {
            const str = window.localStorage.getItem( LOCALSTOR_BOOK_KEY )
            if (str) {
                let locob = JSON.parse( str )
                if ("sid" in locob) {
                    afterbook.value = { ...afterbook_init(), ...locob } 
                    if (!unref(afterbook).status.ok) {
                        let {ts}  = unref(afterbook).status
                        const diff = ts_add_max(ts).diff( dayjs( new Date ), 's'  )
                        if (diff>0) {
                            start_timer(diff)
                        }
                    }
                }
//console.log('locob', locob)
            }
        } catch (e) {
            console.error('bookok load localstor', e)
        }
    },
    { immediate: true }
)

</script>
